import {API_URL, LOGIN_MOBILE_CACHE_KEY, NO_LOGIN_CODE, password} from "./config"
import {aidCAche, openidCache, tokenCache} from "./cache";
import axios from "axios";
import {getGender, getSex} from "@/lib/filter";

/**
 * 是否本地环境
 * @returns {boolean}
 */
export function isDevelopment() {
  return process.env.NODE_ENV === 'development'
}

export function getDeviceId() {
  const deviceIdKey = 'deviceId';
  let deviceId = window.localStorage.getItem(deviceIdKey) || "";
  if (!deviceId) {
    deviceId = hex_md5(hex_md5(password) + window.navigator.userAgent + Date.now() + makeRandom(4));
  }
  window.localStorage.setItem(deviceIdKey, deviceId);
  return "RANDOM_" + deviceId;
}

/**
 * 生成指定长度随机数
 * @param {number} length
 * @returns {string}
 */
export function makeRandom(length) {
  let str = "0123456789", ret = "";
  for (let i = 0; i < length; i++) {
    ret += str.substr(Math.floor(Math.random() * str.length), 1);
  }
  return ret;
}

/**
 * 根据条件返回数组指定元素
 * @param {Array} array
 * @param {(item:any) => boolean} fn
 * @returns {null}
 */
export function arrayFind(array, fn) {
  let index = array.findIndex(fn);
  return index > -1 ? array[index] : null;
}

/**
 * 判断浏览器类型
 * @param {browserType} name
 * @param UA
 * @returns {boolean}
 */
export function isBrower(name, UA) {
  if (!UA) UA = window.navigator.userAgent.toLowerCase();
  return UA.indexOf(name) > -1;
}

/**
 * 从UA获取token
 */
export function getTokenFromUA() {
  const UA = window.navigator.userAgent;
  const tempArray = UA.split(' ');
  Log('tempArray', tempArray)
  let result = '';
  tempArray.forEach(item => {
    const keyValue = item.split('=');
    // Log('keyValue', keyValue);
    if (keyValue.length > 1 && keyValue[0] === 'token' && keyValue[1]) {
      result = keyValue[1];
    }
  })
  return result;
}

/**
 * iPhone webview 打开（非微信、支付宝）
 */
export function isIphoneBrower() {
  return isBrower('iphone') && !isBrower('alipayclient') && !isBrower('micromessenger');
}

/**
 *android  webview 打开（非微信、支付宝）
 */
export function isAndroidBrower() {
  return isBrower('android') && !isBrower('alipayclient') && !isBrower('micromessenger');
}

/**
 * 支付宝
 */
export function isAlipay() {
  return isBrower('alipayclient');
}

// 导出一个函数，用于判断是否为支付宝小程序
export function isAlipayMini() {
  // 判断当前浏览器是否为小程序（miniprogram）
  // 以及是否为支付宝客户端（alipayclient）
  return isBrower('miniprogram') && isBrower('alipayclient');
}


/**
 * 微信
 */
export function isWeixin() {
  return isBrower('micromessenger');
}

export function isAndroid() {
  return isBrower('android');
}

export function isIphone() {
  return isBrower('iphone');
}

/**
 *android  webview 打开（非微信、支付宝）
 */
export function isDocClient(ua) {
  return isBrower('zhe2/doc', ua) || (isBrower('zhe2', ua) && isBrower('doc', ua));
}

/**
 *android  webview 打开（非微信、支付宝）
 */
export function isPatClient(ua) {
  return isBrower('zhe2/pat', ua)
}

export function getClientInfo(ua) {
  let res = '', pat = '患者端', doc = '医生端', wechat = '微信端', alipay = '支付宝', browser = '普通浏览器';
  if (isIphone(ua)) {
    res = 'IOS'
    if (isPatClient(ua)) {
      res += pat
    } else if (isDocClient(ua))
      res += doc;
    else if (isWeixin()) {
      res += wechat
    } else if (isAlipay()) {
      res += alipay
    } else res += browser;
  } else if (isAndroid(ua)) {
    res = '安卓';
    if (isDocClient(ua)) {
      res += doc;
    } else if (isPatClient(ua)) {
      res += pat;
    } else if (isWeixin()) {
      res += wechat
    } else if (isAlipay()) {
      res += alipay
    } else res += browser;
  } else res = '其他'
  return res;
}

/**
 *
 * @returns {{from: string, token: string}}
 */
export function getClientToken() {
  let result = {token: '', from: ''}
  if (isAndroidBrower()) {
    result = {token: getTokenFromUA(), from: 'UA'};
  }
  if (isIphoneBrower()) {
    result = {token: zhe2clientToken, from: 'global var'};
  }
  const {query} = getParamsFromUrl(location.href);
  if (!result.token) {
    if (query.token) {
      result = {token: query.token, from: 'URL'};
    } else result = {token: makeToken(), from: 'cache'};
  }
  // Log('get token from', result);
  return result;
}

/**
 * inZhe2
 * @returns {boolean}
 */
export function inZhe2() {
  return (isAndroidBrower() || isIphoneBrower()) && (isDocClient() || isPatClient());
}

/**
 * 获得api_url
 * @param callback
 * @returns {string}
 */
export function getApiUrl(hostname) {
  if (!hostname) hostname = url("hostname");
  let api_url = "";
  for (let key in API_URL) {
    if (hostname == key) {
      api_url = API_URL[key].api;
    }
  }
  if (!api_url) {
    api_url = API_URL[Object.keys(API_URL)[0]].api;
  }
  return api_url;
}

export function getAppid() {
  let hostname = url("hostname");
  let api_url = "";
  for (let key in API_URL) {
    if (hostname == key) {
      api_url = API_URL[key].appid;
    }
  }
  if (!api_url) {
    api_url = API_URL[Object.keys(API_URL)[0]].appid;
  }
  return api_url;
}

export function getENV() {
  let hostname = url("hostname");
  let env = "";
  for (let key in API_URL) {
    if (hostname == key) {
      env = API_URL[key];
    }
  }
  if (!env) {
    env = API_URL[Object.keys(API_URL)[0]];
  }
  return env;
}

export function envIsDev() {
  return getENV().plat === 'dev'
}

export function envIsTest() {
  const hostname = url("hostname");
  return ["pat-test.gjwlyy.com"].includes(hostname);
}

export function envIsPro() {
  const hostname = url("hostname");
  return ["www.gjwlyy.com", 'app2.z2web1.com'].includes(hostname);
}

// export function getSocket() {
//   let hostname = url("hostname");
//   let api_url = "";
//   for (let key in API_URL) {
//     if (hostname == key) {
//       api_url = API_URL[key].socket;
//     }
//   }
//   if (!api_url) {
//     api_url = API_URL[Object.keys(config.api_url)[0]].socket;
//   }
//   return api_url;
// }


/**
 * 生成返回URL
 * @param options
 * @returns {string}
 */
export function makeUrl(options) {
  let url = "";
  if (options.protocol) {
    url += options.protocol + "://"
  }
  if (options.hostname) {
    url += options.hostname
  }
  if (options.port && options.port != 80 && options.port != 443) {
    url += ':' + options.port
  }
  if (options.path) {
    url += options.path
  }
  if (options.query) {
    let q = "";
    for (let key in options.query) {
      if (options.query[key]) {
        q += `&${key}=${options.query[key]}`
      } else {
        q += `&${key}`
      }

    }
    q = q.substr(1);
    url += "?" + q
  }
  if (options.hash) {
    url += "#" + options.hash;
  }
  return url;
}

/**
 * hash
 * @param hash
 * @param key
 * @param value
 * @returns {*}
 */
export function makeHash(hash, key, value) {
  if (hash.indexOf('?') >= 0) {
    hash += `&${key}=${value}`;
  } else {
    hash += `?${key}=${value}`;
  }
  return hash;
}


/**
 * debug
 * @param args
 */
export function debug(...args) {
  if (1 == 1) {
    console.log.apply(console, args);
  }
}

/**
 * 解析url参数
 * @param from
 * @returns {{protocol: *, hostname: *, port: *, path: *, query: *, hash: *}}
 */
export function getParamsFromUrl(from) {
  let protocol = url("protocol", from);
  let hostname = url("hostname", from);
  let port = url("port", from);
  let path = url("path", from);
  let query = url("?", from);
  let hash = url("hash", from);
  return {protocol, hostname, port, path, query, hash}
}

/**
 * 获得sharelink
 * @param link
 * @returns {string}
 */
export function getShareLink(link, options = {}) {
  let opt = getParamsFromUrl(link)
  opt = Object.assign({}, opt, options);
  if (!isEmpty(opt.query)) {
    opt.query.comefrom = "share"
  } else {
    opt.query = {comefrom: "share"}
  }
  return makeUrl(opt);
}

/**
 * 获得share img
 * @param link
 * @returns {string}
 */
export function getShareImg(p, link = '') {
  if (!link) link = location.href;
  let {path, ...opt} = getParamsFromUrl(link)
  path = path.substring(0, path.lastIndexOf('/') + 1);
  path = path + p;
  opt.path = path;
  return makeUrl(opt);
}

export function getShareImgByChannel(channel) {
  let option = getParamsFromUrl(location.href);
  let path = option.path;
  path = path.substring(0, path.lastIndexOf('/'));
  option.path = path + '/static/img/channel.' + channel + '.png';
  option.hash = "";
  return makeUrl(option);
}

/*首字母大写*/
export function upper(str) {
  return str.substr(0, 1).toUpperCase() + str.substr(1);
}

/**
 * 处理系统消息
 * @param str
 * @returns {string | void | *}
 */
export function handlerHTML(str) {
  Log('str', str, str.match(/\n/g));
  str = str.replace(/\[([^\]]+)\]/g, (...args) => {
    return '<span style="color: #3996f7">' + args[1] + '</span>'
  });
  return str.replace(/[\r\n]/g, '<br/>');
}

/**
 * pick
 * @param map
 * @param obj
 */
export function pick(map, obj) {
  let newObj = {};
  for (let key in map) {
    newObj[key] = obj[map[key]];
  }
  return newObj;
}

/**
 * pickByArray
 * @param arr
 * @param obj
 */
export function pickByArray(arr, obj) {
  let newObj = {};
  for (let key in arr) {
    newObj[arr[key]] = obj[arr[key]];
  }
  return newObj;
}

export function sizeof(str, charset) {
  let total = 0, charCode, i, len;
  charset = charset ? charset.toLowerCase() : '';
  if (charset === 'utf-16' || charset === 'utf16') {
    for (i = 0, len = str.length; i < len; i++) {
      charCode = str.charCodeAt(i);
      if (charCode <= 0xffff) {
        total += 2;
      } else {
        total += 4;
      }
    }
  } else {
    for (i = 0, len = str.length; i < len; i++) {
      charCode = str.charCodeAt(i);
      if (charCode <= 0x007f) {
        total += 1;
      } else if (charCode <= 0x07ff) {
        total += 2;
      } else if (charCode <= 0xffff) {
        total += 3;
      } else {
        total += 4;
      }
    }
  }
  return total;
}

/**
 * 获得js数据类型
 * @param data
 * @returns {string}
 */
export function getJsDataType(data) {
  let type = Object.prototype.toString.call(data);
  type = type.toLowerCase();
  return type.replace(/\[object\s|\]/g, '');
}

/**
 * 空值判断
 * @param data
 * @returns {boolean}
 */
export function isEmpty(data) {
  const type = getJsDataType(data);
  let ret;
  switch (type) {
    case 'array':
      ret = data.length === 0;
      break;
    case 'object':
      ret = Object.keys(data).length === 0;
      break;
    case 'string':
      data = data.replace(/\s/g, '');
      ret = data.length === 0 || data === 'undefined' || data === 'null' || data === 'false';
      break;
    case 'null':
    case 'undefined':
      ret = true;
      break;
    default:
      ret = false;
  }
  return ret;
}

/**
 * get
 * @param obj
 * @returns {string}
 */
export function queryStrBuilder(obj) {
  let str = "";
  for (let key in obj) {
    if (obj[key] !== undefined) str += `&${key}=${obj[key]}`;
  }
  str = '?' + str.substr(1);
  return str;
}

/**
 * @desc 修改浏览器标题兼容微信ios
 * @param title
 * @returns {void}
 */
export function setTitle(title) {
  document.title = title
  // 针对微信中的处理
  const iframe = document.createElement('iframe')
  iframe.src = ''
  iframe.style.display = 'none'
  iframe.onload = () => {
    setTimeout(() => {
      iframe.remove()
    }, 0)
  }
  document.body.appendChild(iframe)
}


export function isDev() {
  const hostname = url("hostname");
  return ["localhost", "wx.hztywl.cn"].includes(hostname);
};


export function hashHasAppid(hash) {
  for (let key in hash) {
    if (key.includes('appid')) return hash[key];
  }
  return false;
}

export function hashHasChannel(hash) {
  for (let key in hash) {
    if (key.includes('channel')) return hash[key];
  }
  return false;
}

export function hashHasToken(hash) {
  for (let key in hash) {
    if (key.includes('token')) return hash[key];
  }
  return false;
}

/**
 * js数据类型判断
 * @param data
 * @returns {string}
 */
export function getDataType(data) {
  return Object.prototype.toString.call(data).replace(/(\[object\s)|\]/g, '')
}

/**
 * 解析微信支付返回参数
 * @param msg
 * @returns {string}
 */
export function parsePayErrMsg(msg) {
  Log('msg类型', getDataType(msg))
  let ret
  switch (getDataType(msg)) {
    case 'Undefined':
      ret = undefined
      break
    case 'Array':
      ret = msg[msg.length - 1]
      break
    case 'String':
      ret = msg
      break
  }
  return ret
}


export const tokenPre = 'TOKEN_';
export const openidPre = 'OPENID_';
export const useridPre = 'ALIPAY_';

/**
 * 组装token
 * @returns {string|null}
 */
export function makeToken() {
  const openid = tokenCache.get() || "";
  if (!openid && !openidCache.get()) return '';
  if (openid.startsWith(tokenPre)) return openid;
  else if (openid.startsWith(openidPre)) return openid;
  else if (openid.startsWith(useridPre)) return openid;
  else if (isWeixin()) return null;
  else if (isAlipay()) {
    return useridPre + openidCache.get();
  } else if (openid)
    return tokenPre + openid;
  return null
}

/**
 * 获取token
 */
export function getToken() {
  const {query = {}} = getParamsFromUrl(location.href);
  return query.token || makeToken();
}

/**
 * 浏览器
 * 微信，支付宝，其他
 * @returns {string}
 */
export function getBrower() {
  return isBrower('alipayclient') ? 'alipay' : isBrower('micromessenger') ? 'weixin' : 'other'
}

/**
 * 读取图片
 * @param url
 * @returns {Promise<any>}
 */
export function readImg(url) {
  let img = new Image()
  return new Promise((resolve, reject) => {
    img.src = url
    img.onload = () => {
      resolve(img)
    }
    img.onerror = (error) => {
      Log('图片加载错误', error)
      reject(error)
    }
  })
}

/**
 * 系统参数是否为true
 * @param val
 * @returns {boolean}
 */
export function xtcsIsTrue(val) {
  if (val === 'true' || val === true) return true;
  return false;
}

/**
 *
 * @param {Number} time
 * @returns {Promise<unknown>}
 */
export function sleep(time) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(1), time)
  })
}

export function getVersion() {
  return axios.get('./static/version.json?t=' + Date.now())
    .then((data) => {
      return data.data;
    })
}

/**
 * 获取文件扩展名、后缀名
 */
export function getFileExt(file) {
  let tmp = file.name.split('.');
  if (tmp.length > 1) return tmp[tmp.length - 1];
  let type = file.type;
  tmp = type.split('/');
  if (tmp.length > 1) return tmp[tmp.length - 1];
  return file.type;
}


const isURLReg = /(https|http):\/\/([^?]+)[?]?([^#]+)?[#]?([^\s]+)?/i

/**
 * 字符串是否包含URL
 * @param str
 * @returns {boolean}
 */
export function hasURL(str) {
  return isURLReg.test(str);
}

export function handlerMsgURL(str) {
  if (!str) return str;
  const res = isURLReg.exec(str);
  Log('reg-result', res);
  if (res[0]) str = str.replace(res[0], `<a href="${res[0]}">${res[0]}</a>`);
  return str;
}

/**
 * 是否需要重新登录
 * @param code
 */
export function needRepeatLogin(code) {
  return NO_LOGIN_CODE.includes(code);
}


export const getWindowWidth = () => {
  return Math.min(window.innerWidth, screen.availWidth);
}

/**
 * 值等于0
 * @param value
 * @returns {boolean}
 */
export const equalZero = (value) => {
  return value === 0 || value === '0'
}

/**
 * 值等于1
 * @param value
 * @returns {boolean}
 */
export const equalOne = (value) => {
  return value === 1 || value === '1'
}

/**
 * 值等于true
 * @param value
 * @returns {boolean}
 */
export const equalTrue = value => value === true || value === 'true'


/**
 * 处理html实体
 * @param str
 * @returns {*}
 */
export function handlerEntityHtml(str) {
  Log('/&amp;/g', /&amp;/g.test(str), str);
  str = str.replace(/&amp;/g, '&');
  return str;
}

/**
 * uuid
 * @returns {string}
 */
export function uuid() {
  const chars = '1234567890qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM';
  let ans = '';
  for (let i = 0; i < 32; i++) {
    ans += chars[0 | (Math.random() * chars.length)];
  }
  return ans;
}

/**
 * 生成操作id，
 * @description 操作ID定义：用户打开网页开始，直到关闭网页结束
 */
export function getAID() {
  const aid = aidCAche.get();
  return aid.value;
}

/**
 * 获取登录缓存在本地的手机号
 * @param query
 * @param $cache
 * @returns {*}
 */
export function getLoginMobile(query = {}, $cache = {}) {
  let mobile = query.mobile;
  if (mobile) return mobile;
  mobile = $cache.get(LOGIN_MOBILE_CACHE_KEY, null);
  if (mobile) return mobile;
  return null;
}

/**
 * 获取就诊人基本文本信息
 * @param data
 */
export function getCompatInfoText(data) {
  const array = [data.compatName, getGender(data.compatGender), data.compatAge ? data.compatAge + '岁' : ''];
  return array.join(' ');
}



// WEBPACK FOOTER //
// ./src/lib/util.js